<template>
  <div class="flex w-full">
    <!-- Menu lateral -->
    <DeshboardSideMenu />

    <div class="w-full bg-white">
      <!-- Barra de navegação do topo -->
      <DashboardHeader/>

      <div id="observed-content" class="w-full rounded-tl-3xl border border-iron" style="background: #f6f8fc">
        <RouterView> </RouterView>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted } from "vue";
  import { RouterView } from "vue-router";
  import DashboardHeader from "@/components/Dashboard/DashboardHeader.vue";
  import DeshboardSideMenu from "@/components/Dashboard/global/DashboardSideMenu/DeshboardSideMenu.vue";
  import store from "@/store";
  import authUser from "@/composables/authUser";

  // Refresh profiles from API so navbar photo stays in sync with curriculum
  // (Vuex persists login snapshot; photo uploads do not update that snapshot).
  onMounted(async () => {
    if (!store.getters.isLoggedIn) return;
    const response = await authUser.profile();
    if (response.success && response.data) {
      store.dispatch("saveLoginInformation", response.data);
    }
  });
</script>